import { AxiosResponse } from "axios";
import ApiConstants from "../../../../core/constants/api_constants";
import { request } from "../../../../core/network/axiosInstance.tsx";

export class ReportApiService {
    private readonly reportApiBaseUrl: string;

    constructor() {
        this.reportApiBaseUrl = ApiConstants().report;
    }

    async report(json: string): Promise<AxiosResponse> {
        const response = await request({
            method: "POST",
            url: `${this.reportApiBaseUrl}`,
            data: json,
            headers: {
                'Content-Type': 'application/json',
            },
            requiresToken: true,
        });
        return response;
    }
}